import { Card, Space } from '@procurify/ui'

import { Tabs } from '@webapp/core/components/Tabs'
import { LegalEntityListPresenter } from '@webapp/platform/legal-entities/features/list-legal-entities/presenters/LegalEntityListPresenter'
import { useLegalEntityListFeatureSet } from './useLegalEntityListFeatureSet'

export const LegalEntityListFeatureSet = () => {
  const {
    state: { isActive, tabs },
    methods: { onAdd, onEdit, onSelect, onDeactivate, onActivate },
  } = useLegalEntityListFeatureSet()

  return (
    <>
      <Tabs>
        {tabs.map((tab) => (
          <Tabs.TabLink key={tab.to} to={tab.to}>
            {tab.label}
          </Tabs.TabLink>
        ))}
      </Tabs>

      <Card>
        <Card.Content>
          <LegalEntityListPresenter
            isActive={isActive}
            onAdd={onAdd}
            onEdit={onEdit}
            onSelect={onSelect}
            onDeactivate={onDeactivate}
            onActivate={onActivate}
          />
        </Card.Content>
      </Card>

      <Space />
    </>
  )
}

LegalEntityListFeatureSet.displayName = 'LegalEntityListFeatureSet'
